module.exports = __webpack_public_path__ + "img/red-error.307f601e.png";